module.exports = __webpack_public_path__ + "static/img/wxtp_20260714114124_84_157.331faa7.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/news/20260714/wxtp_20260714114124_84_157.jpg
// module id = 3o/e
// module chunks = 0